import ooeConstants from '../constants';

export function getHash() {
  const hash = window.location.hash || /* v8 ignore next */ '';
  if (hash.length > 0) {
    const hashString = hash.substr(1);
    const replaceChars = decodeURI(hashString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"');
    return JSON.parse(`{"${replaceChars}"}`);
  }
  return {};
}

export function getActiveStep() {
  const thisPage = window.location.pathname;
  let active = null;
  if (thisPage === ooeConstants.PATH_NAME.SUMMARY) {
    active = 0;
  } else if (thisPage === ooeConstants.PATH_NAME.PAYMENT) {
    active = 1;
  } else if (thisPage === ooeConstants.PATH_NAME.SUCCESS) {
    active = 2;
  }
  return active;
}
